// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d6fRBQHsETKoPhpwfDmg {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}

.EPJaAPKdHMO7ROsCxFZ2 {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.spRXxwwBWsLai4ETEuYK {
  font-size: 14px;
  display: inline-flex;
}

.fQ1qxK28_sqoqoawbqOi {
  font-size: 24px;
}

.LfXApP9bh_MUZ5ZLhGXy {
  line-height: 24px;
  text-align: center;
}

.wRbJ967iCx5gpiKDqq2Q {
  line-height: 18px;
}

.DAhhYTkNWMDKKgSXKnoy {
  position: absolute;
}

.BB2Y22vNJsxoprNDdujx {
  padding: 2px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/components/classification-reason/classification-reason.module.scss"],"names":[],"mappings":"AACA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;AAAF;;AAGA;EACE,eAAA;EACA,oBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,iBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,YAAA;EACA,eAAA;AAAF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.classification_reason_wrapper {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n}\n\n.classification_reason {\n  align-items: center;\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n}\n\n.classification_reason_icon {\n  font-size: 14px;\n  display: inline-flex;\n}\n\n.classification_reason_icon_rha1 {\n  font-size: 24px;\n}\n\n.classification_reason_title {\n  line-height: 24px;\n  text-align: center;\n}\n\n.classification_reason_source {\n  line-height: 18px;\n}\n\n.risk_tolerance_help_container {\n  position: absolute;\n}\n\n.risk_tolerance_help_icon {\n  padding: 2px;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"classification_reason_wrapper": `d6fRBQHsETKoPhpwfDmg`,
	"classification_reason": `EPJaAPKdHMO7ROsCxFZ2`,
	"classification_reason_icon": `spRXxwwBWsLai4ETEuYK`,
	"classification_reason_icon_rha1": `fQ1qxK28_sqoqoawbqOi`,
	"classification_reason_title": `LfXApP9bh_MUZ5ZLhGXy`,
	"classification_reason_source": `wRbJ967iCx5gpiKDqq2Q`,
	"risk_tolerance_help_container": `DAhhYTkNWMDKKgSXKnoy`,
	"risk_tolerance_help_icon": `BB2Y22vNJsxoprNDdujx`
};
export default ___CSS_LOADER_EXPORT___;
